module.exports = __webpack_public_path__ + "img/matt.b817f4fd.jpg";